export function lengthRule(length) {
    return function (input) {
        return input.length === length || length + "\u6587\u5B57\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044";
    };
}
//# sourceMappingURL=length.js.map